export function set({commit}, payload) {
  const data = JSON.stringify(payload)
  this.$cookiz.set("item", data);
  commit('setItem', data);
}

export function get({}) {
  return JSON.parse(this.$cookiz.get("item", { fromRes: true }))
}
